import React from "react"
import {FormattedMessage, injectIntl} from "react-intl"
import {observer} from "mobx-react"
import XsLoading from "../../../../../global/ui/xsLoading/xsLoading"
import moment from "moment"
import classnames from "classnames"

// import UIStore from "../../../stores/UIStore"
import ExportSocInsDeliveryDialog from "./exportSocInsDeliveryDialog"

import SocInsDeliveryFilter from "./socInsDeliveryFilter"
import AddDeliveryDialog from "../../patientDetail/patientDelivery/addDeliveryDialog"

import {
	TableHead,
	TableSortLabel,
	Table,
	Tooltip,
	TableBody,
	TableCell,
	TableRow,
	TablePagination,
	Grid
} from "@material-ui/core"
import InputAdornment from "@material-ui/core/InputAdornment"

import XsIconButton from "../../../../../global/ui/xsButton/xsIconButton"
import XsInputSearchFilter from "../../../../../global/ui/xsInput/xsInputSearchFilter"
import XsDropdownList from "../../../../../global/ui/xsDropdown/xsDropdownList"
import TextField from "@material-ui/core/TextField"
import TablePaginationActions from "../../../../../global/ui/xsTableServer/xsTablePaginationActions"

import api from "../../../actions/api"
import {getSelectedOrgUnitID} from "../../../../../global/helpers/actions"

import SocInsDeliveryStore from "../../../stores/SocInsDeliveryStore"
import GlobalStore from "../../../../../global/store/GlobalStore"
import RouterStore from "../../../../../global/store/RouterStore"
import AddDeliveryStore from "../../../stores/AddDeliveryStore"

import TableStore from "../../../stores/TableStore"

@injectIntl
@observer
export default class SocialInsuranceDeliveryList extends React.Component {
	constructor(props) {
		super(props)

		this.reloadGrid = true

		if (
			isSafe(Object.keys(SocInsDeliveryStore.insureeJSON)) &&
			Object.keys(SocInsDeliveryStore.insureeJSON).length === 0
		) {
			SocInsDeliveryStore.loadInsureeTypes()
		}

		if (
			isSafe(Object.keys(SocInsDeliveryStore.senderJSON)) &&
			Object.keys(SocInsDeliveryStore.senderJSON).length === 0
		) {
			SocInsDeliveryStore.loadSenderType()
		}

		if (
			isSafe(Object.keys(SocInsDeliveryStore.refundJSON)) &&
			Object.keys(SocInsDeliveryStore.refundJSON).length === 0
		) {
			SocInsDeliveryStore.loadRefundTypes()
		}

		if (isSafe(Object.keys(SocInsDeliveryStore.payerJSON)) && Object.keys(SocInsDeliveryStore.payerJSON).length === 0) {
			SocInsDeliveryStore.loadPayerTypes()
		}

		let page = 0
		let rowsPerPage = 10

		if (isNotEmpty("socInsDeliveryList") && TableStore.tables.hasOwnProperty("socInsDeliveryList")) {
			page = +TableStore.tables["socInsDeliveryList"].page
			rowsPerPage = +TableStore.tables["socInsDeliveryList"].rowsPerPage
		}

		SocInsDeliveryStore.page = page
		SocInsDeliveryStore.rowsPerPage = rowsPerPage

		this.state = {
			order: false,
			orderBy: null,
			sortType: ""
		}
	}

	componentDidUpdate() {
		this.reloadGrid = false
	}

	UNSAFE_componentWillReceiveProps() {
		this.reloadGrid = true
	}

	handleChangePage = (event, page) => {
		if (!SocInsDeliveryStore.isEditable) {
			if (
				TableStore.tables.hasOwnProperty("socInsDeliveryList") &&
				TableStore.tables["socInsDeliveryList"].hasOwnProperty("index")
			) {
				delete TableStore.tables["socInsDeliveryList"]["index"]
			}

			SocInsDeliveryStore.page = page
			SocInsDeliveryStore.getFilters()
		}
	}

	handleChangeRowsPerPage = (event) => {
		if (!SocInsDeliveryStore.isEditable) {
			if (
				TableStore.tables.hasOwnProperty("socInsDeliveryList") &&
				TableStore.tables["socInsDeliveryList"].hasOwnProperty("index")
			) {
				delete TableStore.tables["socInsDeliveryList"]["index"]
			}

			SocInsDeliveryStore.rowsPerPage = event.target.value
			SocInsDeliveryStore.getFilters()
		}
	}

	createSortHandler = (property) => (event) => {
		this.handleRequestSort(event, property.columnName, property.type)
	}

	handleRequestSort = (event, property, type) => {
		this.reloadGrid = true
		const orderBy = property
		let order = this.state.order

		switch (order) {
			case "asc":
				order = false
				break
			case false:
				order = "desc"
				break
			default:
				order = "asc"
		}

		if (
			TableStore.tables.hasOwnProperty("socInsDeliveryList") &&
			TableStore.tables["socInsDeliveryList"].hasOwnProperty("index")
		) {
			delete TableStore.tables["socInsDeliveryList"]["index"]
		}

		this.setState({order, orderBy, sortType: type})
	}

	stringComparer = (a, b, direction) => {
		let result
		switch (direction) {
			case "asc":
				result = (isSafe(a) ? a : "").localeCompare(isSafe(b) ? b : "")
				break
			case "desc":
				result = (isSafe(b) ? b : "").localeCompare(isSafe(a) ? a : "")
				break
			default:
				result = 0
		}
		return result
	}

	getInsuranceTooltip = (insurance_type_id) => {
		if (insurance_type_id == "GH") {
			return "Common.label.insuranceVZP"
		}
		if (insurance_type_id == "EU") {
			return "Common.label.insuranceEU"
		}
		if (insurance_type_id == "FRGN") {
			return "Common.label.foreigner"
		}
	}

	getInsuranceCodeExt = (insuranceTypeId) => {
		let insType = GlobalStore.CL["insuranceTypes"].filter((x) => x.code == insuranceTypeId)

		if (isSafe(insType) && insType.length > 0) {
			return ` (${insType[0].code_ext})`
		} else {
			return ""
		}
	}

	tableBodyRows
	tableBody() {
		const {order, orderBy, sortType} = this.state

		//let dataSource = isSafe(this.data) ? this.data : []
		let dataSource = SocInsDeliveryStore.socInsDeliveryList

		if (isSafe(orderBy)) {
			switch (sortType) {
				case "string":
					dataSource = dataSource.slice().sort((a, b) => this.stringComparer(a[orderBy], b[orderBy], order))
					break
				case "number":
					dataSource = dataSource.slice().sort((a, b) => this.numberComparer(a[orderBy], b[orderBy], order))
					break
				case "datetime":
					dataSource = dataSource.slice().sort((a, b) => this.dateComparer(a[orderBy], b[orderBy], order))
					break
			}
		}

		SocInsDeliveryStore.isValidGrid = true

		this.tableBodyRows = []
		{
			if (isSafe(dataSource) && dataSource.length > 0) {
				dataSource.forEach((currRow, idx) => {
					if (!SocInsDeliveryStore.removeDeliveryIds.includes(currRow._id)) {
						let row = currRow
						if (SocInsDeliveryStore.changedData[currRow._id]) {
							row = Object.assign({}, currRow, SocInsDeliveryStore.changedData[row._id])
						}
						let countSubItemsPerRow = 0
						let colorSubItemsPerRow = "#E0E5EF"

						if (SocInsDeliveryStore.changedKeysTest.hasOwnProperty(row._id)) {
							colorSubItemsPerRow = "#8BC34A"
							let isValid = true

							if (!isNumber(row.count) || isEmpty(row.diagnosis_code) || isEmpty(row.item_code_ext)) {
								isValid = false
							}
							Object.keys(SocInsDeliveryStore.changedKeysTest[row._id]).forEach((ppId) => {
								if (
									!isPrice(SocInsDeliveryStore.subItems[row._id][ppId].unit_price) ||
									!isNumber(SocInsDeliveryStore.subItems[row._id][ppId].quantity)
								) {
									isValid = false
								}

								if (
									isSafe(SocInsDeliveryStore.subItems[row._id][ppId].sub_type) &&
									(SocInsDeliveryStore.subItems[row._id][ppId].sub_type === "adidrug" ||
										SocInsDeliveryStore.subItems[row._id][ppId].sub_type === "adidev" ||
										SocInsDeliveryStore.subItems[row._id][ppId].sub_type === "adicntr")
								) {
									if (isEmpty(SocInsDeliveryStore.subItems[row._id][ppId].drugs)) {
										isValid = false
									}
								} else {
									if (isEmpty(SocInsDeliveryStore.subItems[row._id][ppId].subItemType)) {
										isValid = false
									}
								}
							})
							if (!isValid) {
								colorSubItemsPerRow = "#E91E63"
								SocInsDeliveryStore.isValidGrid = false
							}
							if (SocInsDeliveryStore.subItems.hasOwnProperty(row._id)) {
								countSubItemsPerRow = Object.keys(SocInsDeliveryStore.subItems[row._id]).length
							}
						} else {
							countSubItemsPerRow = row.sub_items.length
						}

						let selectedRow = false

						if (
							TableStore.tables.hasOwnProperty("socInsDeliveryList") &&
							isNotEmpty(TableStore.tables["socInsDeliveryList"].index) &&
							idx == TableStore.tables["socInsDeliveryList"].index
						) {
							selectedRow = true
						}

						const deliveryExtension =
							isSafe(row.delivery_extension) && isNotEmpty(row.delivery_extension.code_ext)
								? `(${row.delivery_extension.code_ext})`
								: ""
						const deliveryText = `${row.item_code_ext} ${deliveryExtension} ${row.item_name_ext}`

						// mapper flat napisat, osetrit nulovanie pri cancel a save a pri  search dat flag na renderovanie kvoli novemu riadku
						this.tableBodyRows.push(
							<TableRow key={idx}>
								<TableCell
									width="100px"
									className={classnames({bgBlueLight: selectedRow && !SocInsDeliveryStore.isEditable})}
								>
									{isSafe(row.created_at) ? moment(row.created_at).format("DD.MM.YYYY") : ""}
								</TableCell>
								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<div>{row.person_name + " " + this.getInsuranceCodeExt(row.insurance_type_id)}</div>
										<div>{row.person_identifier}</div>
									</TableCell>
								) : (
									<TableCell
										className={classnames("blueDark xs-bold pointer", {bgBlueLight: selectedRow})}
										onClick={() => {
											TableStore.tables["socInsDeliveryList"] = {
												index: idx,
												rowsPerPage: SocInsDeliveryStore.rowsPerPage,
												page: SocInsDeliveryStore.page
											}
											RouterStore.push(`/patient?id=${row.person_id}`)
										}}
									>
										<div>
											{row.person_name}
											{row.insurance_type_id == "GH" ||
											row.insurance_type_id == "EU" ||
											row.insurance_type_id == "FRGN" ? (
												<Tooltip
													title={this.props.intl.formatMessage({
														id: this.getInsuranceTooltip(row.insurance_type_id)
													})}
												>
													<span className="xs-insurer"> {this.getInsuranceCodeExt(row.insurance_type_id)}</span>
												</Tooltip>
											) : (
												<span className="xs-insurer">{this.getInsuranceCodeExt(row.insurance_type_id)}</span>
											)}
										</div>
										<div>{row.person_identifier}</div>
									</TableCell>
								)}
								<TableCell className={classnames({bgBlueLight: selectedRow && !SocInsDeliveryStore.isEditable})}>
									{row.person_age}
								</TableCell>
								<TableCell className={classnames({bgBlueLight: selectedRow && !SocInsDeliveryStore.isEditable})}>
									{row.insurer_name_ext}
								</TableCell>

								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<XsInputSearchFilter
											clearText
											api={api.loadDiagnosisCl}
											minLengthForSearch={3}
											className={isEmpty(row.item_code_ext) ? "xs-input-error xs-input" : "xs-input"}
											onButtonClick={(value) =>
												delayedCallback(500, () => SocInsDeliveryStore.searchDiagnosis(value, idx))
											}
											data={SocInsDeliveryStore.diagnosis[idx]}
											onSearchClose={() => (SocInsDeliveryStore.diagnosis[idx] = [])}
											defaultValue={row.diagnosis_code + " " + row.diagnosis_name_ext}
											inputRenderer={(dataRow) => {
												return dataRow.code_ext + " " + dataRow.name_ext
											}}
											valueRenderer={(dataRow) => {
												return dataRow.code_ext + " " + dataRow.name_ext
											}}
											chooseItem={(value) =>
												SocInsDeliveryStore.changeDelivery("diagnosis_name_ext", row._id, value._id)
											}
											modalTitle={<FormattedMessage id="Common.label.diagnosis" />}
											modalConfig={(textValue, clickHandler) => {
												return {
													columnDefs: {
														code_ext: {
															title: <FormattedMessage id="Delivery.list.modal.diagnosesCode" />,
															type: "string",
															dbName: "code_ext",
															design: {
																width: "150px"
															},
															filter: {
																gridWidth: 3,
																defaultValue: "",
																renderElement: "input"
															}
														},
														name_ext: {
															title: <FormattedMessage id="Delivery.list.modal.diagnosesName" />,
															type: "string",
															dbName: "search_column",
															filter: {
																gridWidth: 9,
																defaultValue: textValue,
																renderElement: "input"
															}
															// sortable: true
														}
													},
													options: {
														// selectRow: true,
														showCursor: true,
														onRowClick: (dataRow) => {
															clickHandler(dataRow)
														}
													}
												}
											}}
										/>
									</TableCell>
								) : (
									<TableCell className={classnames({bgBlueLight: selectedRow})}>
										{row.diagnosis_code + " " + row.diagnosis_name_ext}
									</TableCell>
								) //row.diagnosis_name_ext
								}
								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<XsInputSearchFilter
											clearText
											api={api.loadDeliveries}
											minLengthForSearch={1}
											className={isEmpty(row.item_code_ext) ? "xs-input-error xs-input" : "xs-input"}
											onButtonClick={(value) =>
												delayedCallback(500, () => SocInsDeliveryStore.searchDeliveries(value, idx))
											}
											data={SocInsDeliveryStore.deliveries[idx]}
											onSearchClose={() => (SocInsDeliveryStore.deliveries[idx] = [])}
											defaultValue={row.item_code_ext + " " + row.item_name_ext}
											inputRenderer={(dataRow) => {
												return dataRow.code_ext + " " + dataRow.name_ext
											}}
											valueRenderer={(dataRow) => {
												return dataRow.name_ext
											}}
											chooseItem={(value) => SocInsDeliveryStore.changeDelivery("item_code_ext", row._id, value._id)}
											modalTitle={<FormattedMessage id="Delivery.list.modal.delivery.title" />}
											modalConfig={(textValue, clickHandler) => {
												return {
													columnDefs: {
														code_ext: {
															title: <FormattedMessage id="Delivery.list.modal.deliveryCode" />,
															type: "string",
															dbName: "code_ext",
															design: {
																width: "150px"
															},
															filter: {
																gridWidth: 3,
																defaultValue: "",
																renderElement: "input"
															}
														},
														name_ext: {
															title: <FormattedMessage id="Delivery.list.modal.deliveryName" />,
															type: "string",
															dbName: "search_column",
															filter: {
																gridWidth: 9,
																defaultValue: textValue,
																renderElement: "input"
															}
															// sortable: true
														}
													},
													options: {
														// selectRow: true,
														showCursor: true,
														onRowClick: (dataRow) => {
															clickHandler(dataRow)
														}
													}
												}
											}}
										/>
									</TableCell>
								) : (
									<TableCell className={classnames({bgBlueLight: selectedRow})}>{deliveryText}</TableCell>
								)}
								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<XsDropdownList
											emptyValue
											className="xs-dropdown"
											items={GlobalStore.CL["senderType"]}
											renderer={(item) => {
												return <span>{item.name_ext}</span>
											}}
											column="_id"
											value={SocInsDeliveryStore.senderTypesJSON[row._id]}
											chooseItem={(item) => {
												{
													SocInsDeliveryStore.changeDelivery("sender_type", row._id, item._id)
													SocInsDeliveryStore.senderTypesJSON[row._id] = item._id
												}
											}}
										/>
									</TableCell>
								) : (
									<TableCell className={classnames("xs-no-wrap", {bgBlueLight: selectedRow})}>
										{SocInsDeliveryStore.senderJSON[row.sender_type]}
									</TableCell>
								)}
								{SocInsDeliveryStore.isEditable ? (
									<TableCell width="75px">
										<TextField
											className="xs-count"
											InputProps={{
												classes: {
													root: !isNumber(row.count) ? "xs-input-error xs-input" : "xs-input"
												}
											}}
											value={row.count}
											onChange={(e) => SocInsDeliveryStore.changeDelivery("count", row._id, e.target.value)}
										/>
									</TableCell>
								) : (
									<TableCell width="75px" className={classnames({bgBlueLight: selectedRow})}>
										{row.count}
									</TableCell>
								)}
								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<XsDropdownList
											emptyValue
											className="xs-dropdown"
											items={GlobalStore.CL["payerType"]}
											renderer={(item) => {
												return <span>{item.name_ext}</span>
											}}
											column="_id"
											value={SocInsDeliveryStore.payerTypesJSON[row._id]}
											chooseItem={(item) => {
												{
													SocInsDeliveryStore.changeDelivery("payer_type", row._id, item._id)
													SocInsDeliveryStore.payerTypesJSON[row._id] = item._id
												}
											}}
										/>
									</TableCell>
								) : (
									<TableCell className={classnames({bgBlueLight: selectedRow})}>
										{SocInsDeliveryStore.payerJSON[row.payer_type]}
									</TableCell>
								)}
								<TableCell
									width="100px"
									className={classnames({bgBlueLight: selectedRow && !SocInsDeliveryStore.isEditable})}
								>
									{row.price_in_points}
								</TableCell>
								<TableCell
									width="100px"
									className={classnames({bgBlueLight: selectedRow && !SocInsDeliveryStore.isEditable})}
								>
									{row.price_in_currency}
								</TableCell>
								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<XsDropdownList
											emptyValue
											className="xs-dropdown"
											items={GlobalStore.CL["insureeType"]}
											renderer={(item) => {
												return <span>{item.name_ext}</span>
											}}
											column="_id"
											value={SocInsDeliveryStore.insureeTypesJSON[row._id]}
											chooseItem={(item) => {
												{
													SocInsDeliveryStore.changeDelivery("insuree_type", row._id, item._id)
													SocInsDeliveryStore.insureeTypesJSON[row._id] = item._id
												}
											}}
										/>
									</TableCell>
								) : (
									<TableCell className={classnames("xs-no-wrap", {bgBlueLight: selectedRow})}>
										{SocInsDeliveryStore.insureeJSON[row.insuree_type]}
									</TableCell>
								)}
								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<XsDropdownList
											emptyValue
											className="xs-dropdown"
											items={GlobalStore.CL["refundType"]}
											renderer={(item) => {
												return <span>{item.name_ext}</span>
											}}
											column="_id"
											value={SocInsDeliveryStore.refundTypesJSON[row._id]}
											chooseItem={(item) => {
												{
													SocInsDeliveryStore.changeDelivery("refund_type", row._id, item._id)
													SocInsDeliveryStore.refundTypesJSON[row._id] = item._id
												}
											}}
										/>
									</TableCell>
								) : (
									<TableCell className={classnames("xs-no-wrap", {bgBlueLight: selectedRow})}>
										{SocInsDeliveryStore.refundJSON[row.refund_type]}
									</TableCell>
								)}
								{SocInsDeliveryStore.isEditable ? (
									<TableCell>
										<TextField
											className="xs-movement"
											InputProps={{
												classes: {
													root: "xs-input"
												}
											}}
											value={row.movement}
											onChange={(e) => SocInsDeliveryStore.changeDelivery("movement", row._id, e.target.value)}
										/>
									</TableCell>
								) : (
									<TableCell className={classnames({bgBlueLight: selectedRow})}>{row.movement}</TableCell>
								)}
								{SocInsDeliveryStore.isEditable && (
									<TableCell width="40px" className="xs-align-text">
										<Tooltip
											title={this.props.intl.formatMessage({
												id:
													countSubItemsPerRow > 0
														? "Common.label.removeDeliveryContainsPP"
														: "Common.label.removeDelivery"
											})}
										>
											<i
												className={`fal fa-trash-alt fa-lg ${countSubItemsPerRow == 0 && "xs-redDanger"}`}
												onClick={() => (countSubItemsPerRow > 0 ? null : SocInsDeliveryStore.removeDelivery(row._id))}
											/>
										</Tooltip>
									</TableCell>
								)}
								<TableCell
									width="40px"
									className={classnames("xs-align-text", {
										bgBlueLight: selectedRow && !SocInsDeliveryStore.isEditable
									})}
								>
									<XsIconButton
										className="xs-default xs-outline"
										style={{borderColor: colorSubItemsPerRow, backgroundColor: colorSubItemsPerRow, color: "#21212F"}}
										icon={countSubItemsPerRow}
										onClick={() => {
											SocInsDeliveryStore.createSubItemPP(row)
										}}
									/>
								</TableCell>
								{!SocInsDeliveryStore.isEditable && (
									<TableCell width="40px" className={classnames("xs-align-text", {bgBlueLight: selectedRow})}>
										<XsIconButton
											className="xs-success xs-outline"
											icon={<i className="fal fa-plus fa-lg greenSuccess" />}
											onClick={() => {
												AddDeliveryStore.open("socDelivery", {
													date: row.created_at,
													payerType: SocInsDeliveryStore.payerTypesJSON[row._id],
													diagnosis: row.diagnosis_id,
													patientId: row.patient_id
												})
											}}
										/>
									</TableCell>
								)}
							</TableRow>
						)
						// pridavanie riadku do gridy vo vynimocnych pripadoch!!!!, ak sa vyberie vykon ktoremu treba doplnujuce udaje
						if (
							SocInsDeliveryStore.idSubItemsRow === row._id &&
							isSafe(SocInsDeliveryStore.subItems) &&
							isSafe(SocInsDeliveryStore.subItems[row._id])
						) {
							const countSubItems = Object.keys(SocInsDeliveryStore.subItems[row._id]).length
							this.tableBodyRows.push(
								<TableRow key={idx + 10000}>
									<TableCell colSpan={12}>
										<Grid container direction="column">
											{Object.keys(SocInsDeliveryStore.subItems[row._id]).map((key, index) => {
												return (
													<Grid item xs={12} key={`${idx}_${index}`}>
														<Grid container direction="row" spacing={8} alignItems="center">
															<Grid item xs={2}>
																<XsDropdownList
																	disabled={!SocInsDeliveryStore.isEditable}
																	label={
																		<span className="xs-bold">
																			<FormattedMessage id="Delivery.List.Type" />*
																		</span>
																	}
																	items={GlobalStore.CL["generalSubItemType"]}
																	renderer={(item) => {
																		return <span>{item.name_ext}</span>
																	}}
																	column="_id"
																	value={
																		isSafe(SocInsDeliveryStore.subItems[row._id][key].sub_type)
																			? SocInsDeliveryStore.subItems[row._id][key].sub_type
																			: "adigen"
																	}
																	chooseItem={(item) => {
																		{
																			SocInsDeliveryStore.changeSubItem("sub_type", row._id, key, item._id)
																		}
																	}}
																	onChange={() => {
																		if (isSafe(SocInsDeliveryStore.subItems[row._id][key].unit_price)) {
																			SocInsDeliveryStore.subItems[row._id][key].unit_price = ""
																		}
																		if (isSafe(SocInsDeliveryStore.subItems[row._id][key].quantity)) {
																			SocInsDeliveryStore.subItems[row._id][key].quantity = 1
																		}
																		if (isSafe(SocInsDeliveryStore.subItems[row._id][key].drugs)) {
																			SocInsDeliveryStore.subItems[row._id][key].drugs = ""
																		}
																		if (isSafe(SocInsDeliveryStore.subItems[row._id][key].drugsName)) {
																			SocInsDeliveryStore.subItems[row._id][key].drugsName = ""
																		}
																		if (isSafe(SocInsDeliveryStore.subItems[row._id][key].description)) {
																			SocInsDeliveryStore.subItems[row._id][key].description = ""
																		}
																		if (isSafe(SocInsDeliveryStore.subItems[row._id][key].subItemType)) {
																			SocInsDeliveryStore.subItems[row._id][key].subItemType = ""
																		}
																	}}
																/>
															</Grid>
															{isSafe(SocInsDeliveryStore.subItems[row._id][key].sub_type) &&
																SocInsDeliveryStore.subItems[row._id][key].sub_type === "adidrug" && (
																	<Grid item xs={2}>
																		<XsInputSearchFilter
																			api={api.loadDrug}
																			disabled={!SocInsDeliveryStore.isEditable}
																			isValid={isEmpty(SocInsDeliveryStore.subItems[row._id][key].drugs)}
																			label={
																				<span className="xs-bold">
																					<FormattedMessage id="Delivery.List.Item" />*
																				</span>
																			}
																			minLengthForSearch={3}
																			onButtonClick={(value) =>
																				delayedCallback(500, () => SocInsDeliveryStore.searchDrugs(value, key))
																			}
																			data={SocInsDeliveryStore.drugs[key]}
																			onSearchClose={() => (SocInsDeliveryStore.drugs[key] = [])}
																			defaultValue={
																				isSafe(SocInsDeliveryStore.subItems[row._id][key].drugs)
																					? SocInsDeliveryStore.subItems[row._id][key].drugsName
																					: ""
																			}
																			className="xs-search-grid"
																			// inputRenderer={(dataRow) => { return dataRow.code_ext + " " + dataRow.name_ext }}
																			inputRenderer={(obj) =>
																				obj.code_ext +
																				" | " +
																				obj.name_ext +
																				" | " +
																				obj.supplement +
																				" | " +
																				(obj.patient_payment ? obj.patient_payment + " | " : "") +
																				(obj.insurer_payment ? obj.insurer_payment + " | " : "") +
																				obj.atc +
																				" | " +
																				obj.active_ingredient
																			}
																			// valueRenderer={(dataRow) => { return dataRow.code_ext + " " + dataRow.name_ext }}
																			valueRenderer={(obj) =>
																				obj.code_ext +
																				" | " +
																				obj.name_ext +
																				" | " +
																				obj.supplement +
																				" | " +
																				(obj.patient_payment ? obj.patient_payment + " | " : "") +
																				(obj.insurer_payment ? obj.insurer_payment + " | " : "") +
																				obj.atc +
																				" | " +
																				obj.active_ingredient
																			}
																			chooseItem={(value) => {
																				SocInsDeliveryStore.changeSubItem("drugs", row._id, key, value._id)
																				if (isNotEmpty(value.insurer_bs_unit_price)) {
																					SocInsDeliveryStore.subItems[row._id][key].unit_price =
																						value.insurer_bs_unit_price
																					SocInsDeliveryStore.subItems[row._id][key].adorment = value.bs_unit
																				} else {
																					SocInsDeliveryStore.subItems[row._id][key].unit_price = ""
																				}
																			}}
																			onClear={() => {
																				SocInsDeliveryStore.subItems[row._id][key].unit_price = ""
																				SocInsDeliveryStore.subItems[row._id][key].drugsName = ""
																				SocInsDeliveryStore.subItems[row._id][key].drugs = ""
																			}}
																			modalTitle={<FormattedMessage id="Common.label.drugs" />}
																			modalConfig={(textValue, clickHandler) => {
																				return {
																					columnDefs: {
																						code_ext: {
																							title: <FormattedMessage id="Delivery.list.modal.drugCode" />,
																							type: "string",
																							dbName: "code_ext",
																							design: {
																								width: "90px"
																							},
																							filter: {
																								gridWidth: 3,
																								defaultValue: "",
																								renderElement: "input"
																							}
																						},
																						name_ext: {
																							title: <FormattedMessage id="Delivery.list.modal.drugName" />,
																							type: "string",
																							dbName: "search_column",
																							filter: {
																								gridWidth: 9,
																								defaultValue: textValue,
																								renderElement: "input"
																							}
																						},
																						supplement: {
																							title: (
																								<FormattedMessage id="Patient.form.patientPrescription.drugsTable.supplement" />
																							),
																							type: "string",
																							dbName: "supplement",
																							design: {
																								width: "150px"
																							}
																						},
																						patient_payment: {
																							title: (
																								<FormattedMessage id="Patient.form.patientPrescription.drugsTable.patient_payment" />
																							),
																							type: "string",
																							dbName: "patient_payment",
																							design: {
																								width: "80px"
																							}
																						},
																						insurer_payment: {
																							title: (
																								<FormattedMessage id="Patient.form.patientPrescription.drugsTable.insurer_payment" />
																							),
																							type: "string",
																							dbName: "insurer_payment",
																							design: {
																								width: "80px"
																							}
																						},
																						atc: {
																							title: (
																								<FormattedMessage id="Patient.form.patientPrescription.drugsTable.ATC" />
																							),
																							type: "string",
																							dbName: "atc",
																							design: {
																								width: "90px"
																							}
																						}
																					},
																					filterValue: [
																						{
																							associated_column: "only_bsu",
																							predicate: "=",
																							values: [
																								{
																									id_value: 1
																								}
																							]
																						}
																					],
																					options: {
																						// selectRow: true,
																						showCursor: true,
																						onRowClick: (dataRow) => {
																							clickHandler(dataRow)
																						},
																						renderHeaderAsFirstRow: true
																					}
																				}
																			}}
																		/>
																	</Grid>
																)}
															{isSafe(SocInsDeliveryStore.subItems[row._id][key].sub_type) &&
																SocInsDeliveryStore.subItems[row._id][key].sub_type === "adidev" && (
																	<Grid item xs={2}>
																		<XsInputSearchFilter
																			api={api.loadMedDev}
																			disabled={!SocInsDeliveryStore.isEditable}
																			isValid={isEmpty(SocInsDeliveryStore.subItems[row._id][key].drugs)}
																			label={
																				<span className="xs-bold">
																					<FormattedMessage id="Delivery.List.Item" />*
																				</span>
																			}
																			minLengthForSearch={3}
																			onButtonClick={(value) =>
																				delayedCallback(500, () => SocInsDeliveryStore.searchMedicalDevices(value, key))
																			}
																			data={SocInsDeliveryStore.medicalDevices[key]}
																			onSearchClose={() => (SocInsDeliveryStore.medicalDevices[key] = [])}
																			defaultValue={
																				isSafe(SocInsDeliveryStore.subItems[row._id][key].drugs)
																					? SocInsDeliveryStore.subItems[row._id][key].drugsName
																					: ""
																			}
																			className="xs-search-grid"
																			inputRenderer={(obj) => {
																				return obj.code_ext + " | " + obj.name_ext + " | " + obj.supplement
																			}}
																			valueRenderer={(obj) => {
																				return obj.code_ext + " | " + obj.name_ext + " | " + obj.supplement
																			}}
																			chooseItem={(value) => {
																				SocInsDeliveryStore.changeSubItem("drugs", row._id, key, value._id)
																			}}
																			onClear={() => {
																				SocInsDeliveryStore.subItems[row._id][key].drugsName = ""
																				SocInsDeliveryStore.subItems[row._id][key].drugs = ""
																			}}
																			modalTitle={<FormattedMessage id="Delivery.list.modal.help.title" />}
																			modalConfig={(textValue, clickHandler) => {
																				return {
																					columnDefs: {
																						code_ext: {
																							title: <FormattedMessage id="Delivery.list.modal.helpCode" />,
																							type: "string",
																							dbName: "code_ext",
																							design: {
																								width: "120px"
																							},
																							filter: {
																								gridWidth: 3,
																								defaultValue: "",
																								renderElement: "input"
																							}
																						},
																						name_ext: {
																							title: <FormattedMessage id="Delivery.list.modal.helpName" />,
																							type: "string",
																							dbName: "search_column",
																							filter: {
																								gridWidth: 9,
																								defaultValue: textValue,
																								renderElement: "input"
																							}
																						},
																						supplement: {
																							title: (
																								<FormattedMessage id="Patient.form.patientPrescription.drugsTable.supplement" />
																							),
																							type: "string",
																							dbName: "supplement",
																							design: {
																								width: "225px"
																							}
																						}
																					},
																					options: {
																						// selectRow: true,
																						showCursor: true,
																						onRowClick: (dataRow) => {
																							clickHandler(dataRow)
																						}
																					}
																				}
																			}}
																		/>
																	</Grid>
																)}
															{isSafe(SocInsDeliveryStore.subItems[row._id][key].sub_type) &&
																SocInsDeliveryStore.subItems[row._id][key].sub_type === "adicntr" && (
																	<Grid item xs={2}>
																		<XsInputSearchFilter
																			api={api.loadCustomItem}
																			disabled={!SocInsDeliveryStore.isEditable}
																			isValid={isEmpty(SocInsDeliveryStore.subItems[row._id][key].drugs)}
																			label={
																				<span className="xs-bold">
																					<FormattedMessage id="Delivery.List.Item" />*
																				</span>
																			}
																			minLengthForSearch={3}
																			onButtonClick={(value) =>
																				delayedCallback(500, () => SocInsDeliveryStore.searchCustomItems(value, key))
																			}
																			data={SocInsDeliveryStore.customItems[key]}
																			onSearchClose={() => (SocInsDeliveryStore.customItems[key] = [])}
																			defaultValue={
																				isSafe(SocInsDeliveryStore.subItems[row._id][key].drugs)
																					? SocInsDeliveryStore.subItems[row._id][key].drugsName
																					: ""
																			}
																			className="xs-search-grid"
																			inputRenderer={(obj) => {
																				return obj.code_ext + " | " + obj.name_ext
																			}}
																			valueRenderer={(obj) => {
																				return obj.code_ext + " | " + obj.name_ext
																			}}
																			chooseItem={(value) => {
																				SocInsDeliveryStore.changeSubItem("drugs", row._id, key, value._id)
																				if (isNotEmpty(row.insurerId)) {
																					api
																						.getDeliveryItemPrice(value._id, {
																							org_unit_id: getSelectedOrgUnitID(),
																							insurer_id: row.insurerId,
																							date: isNotEmpty(row.delivery_date_time)
																								? moment(row.delivery_date_time).format("YYYY-MM-DD")
																								: moment().format("YYYY-MM-DD")
																						})
																						.call()
																						.then((res) => {
																							if (isSafe(res) && isNotEmpty(res.price_in_currency)) {
																								SocInsDeliveryStore.subItems[row._id][key].unit_price =
																									res.price_in_currency
																							} else {
																								if (isNotEmpty(value.price_in_currency)) {
																									SocInsDeliveryStore.subItems[row._id][key].unit_price =
																										value.price_in_currency
																								} else {
																									SocInsDeliveryStore.subItems[row._id][key].unit_price = ""
																								}
																							}
																						})
																				}
																			}}
																			onClear={() => {
																				SocInsDeliveryStore.subItems[row._id][key].unit_price = ""
																				SocInsDeliveryStore.subItems[row._id][key].drugsName = ""
																				SocInsDeliveryStore.subItems[row._id][key].drugs = ""
																			}}
																			modalTitle={<FormattedMessage id="Common.label.addItems" />}
																			modalConfig={(textValue, clickHandler) => {
																				return {
																					columnDefs: {
																						code_ext: {
																							title: <FormattedMessage id="Common.label.code" />,
																							type: "string",
																							dbName: "code_ext",
																							design: {
																								width: "120px"
																							},
																							filter: {
																								gridWidth: 3,
																								defaultValue: "",
																								renderElement: "input"
																							}
																						},
																						name_ext: {
																							title: <FormattedMessage id="Common.label.name" />,
																							type: "string",
																							dbName: "search_column",
																							filter: {
																								gridWidth: 9,
																								defaultValue: textValue,
																								renderElement: "input"
																							}
																						}
																					},
																					options: {
																						// selectRow: true,
																						showCursor: true,
																						onRowClick: (dataRow) => {
																							clickHandler(dataRow)
																						}
																					}
																				}
																			}}
																		/>
																	</Grid>
																)}
															{((isSafe(SocInsDeliveryStore.subItems[row._id][key].sub_type) &&
																(SocInsDeliveryStore.subItems[row._id][key].sub_type === "adigen" ||
																	SocInsDeliveryStore.subItems[row._id][key].sub_type === "drg")) ||
																isEmpty(SocInsDeliveryStore.subItems[row._id][key].sub_type)) && (
																<Grid item xs={2}>
																	<TextField
																		disabled={!SocInsDeliveryStore.isEditable}
																		label={
																			<span className="xs-bold">
																				<FormattedMessage id="Delivery.List.Item" />*
																			</span>
																		}
																		value={
																			isSafe(SocInsDeliveryStore.subItems[row._id][key].subItemType)
																				? SocInsDeliveryStore.subItems[row._id][key].subItemType
																				: ""
																		}
																		onChange={(e) => {
																			SocInsDeliveryStore.changeSubItem("subItemType", row._id, key, e.target.value)
																			// SocInsDeliveryStore.changeSubItem("sub_type", row._id, key, "adigen") //TODO: davat bacha, teraz to je jedno lebo adigen a drg su tie iste podmienky, ale ked bude ine, treba upravit!
																		}}
																		InputLabelProps={{
																			shrink: true
																		}}
																		InputProps={{
																			classes: {
																				root: isEmpty(SocInsDeliveryStore.subItems[row._id][key].subItemType)
																					? "xs-input-error"
																					: ""
																			}
																		}}
																	/>
																</Grid>
															)}
															<Grid item xs={1}>
																<TextField
																	disabled={!SocInsDeliveryStore.isEditable}
																	label={
																		<span className="xs-bold">
																			<FormattedMessage id="Delivery.List.Quantity" />*
																		</span>
																	}
																	value={
																		isSafe(SocInsDeliveryStore.subItems[row._id][key].quantity)
																			? SocInsDeliveryStore.subItems[row._id][key].quantity
																			: ""
																	}
																	onChange={(e) =>
																		SocInsDeliveryStore.changeSubItem("quantity", row._id, key, e.target.value)
																	}
																	InputLabelProps={{
																		shrink: true
																	}}
																	InputProps={{
																		classes: {
																			root: !isNumber(SocInsDeliveryStore.subItems[row._id][key].quantity)
																				? "xs-input-error"
																				: ""
																		}
																	}}
																/>
															</Grid>
															<Grid item xs={2}>
																<TextField
																	disabled={!SocInsDeliveryStore.isEditable}
																	label={
																		<span className="xs-bold">
																			<FormattedMessage id="Delivery.List.UnitPrice" />*
																		</span>
																	}
																	value={
																		isSafe(SocInsDeliveryStore.subItems[row._id][key].unit_price)
																			? SocInsDeliveryStore.subItems[row._id][key].unit_price
																			: ""
																	}
																	onChange={(e) =>
																		SocInsDeliveryStore.changeSubItem("unit_price", row._id, key, e.target.value)
																	}
																	InputLabelProps={{
																		shrink: true
																	}}
																	InputProps={{
																		classes: {
																			root: !isPrice(SocInsDeliveryStore.subItems[row._id][key].unit_price)
																				? "xs-input-error"
																				: ""
																		},
																		endAdornment:
																			isNotEmpty(SocInsDeliveryStore.subItems[row._id][key].unit_price) &&
																			isNotEmpty(SocInsDeliveryStore.subItems[row._id][key].adorment) ? (
																				<InputAdornment
																					position="end"
																					variant="filled"
																					className="xs-unit-price-adorment"
																				>
																					{SocInsDeliveryStore.subItems[row._id][key].adorment}
																				</InputAdornment>
																			) : null
																	}}
																/>
															</Grid>
															<Grid item xs={4}>
																{!(
																	(isSafe(SocInsDeliveryStore.subItems[row._id][key].sub_type) &&
																		(SocInsDeliveryStore.subItems[row._id][key].sub_type === "adigen" ||
																			SocInsDeliveryStore.subItems[row._id][key].sub_type === "drg")) ||
																	isEmpty(SocInsDeliveryStore.subItems[row._id][key].sub_type)
																) && (
																	<TextField
																		disabled={!SocInsDeliveryStore.isEditable}
																		label={<FormattedMessage id="Common.label.description" />}
																		defaultValue={
																			isSafe(SocInsDeliveryStore.subItems[row._id][key].description)
																				? SocInsDeliveryStore.subItems[row._id][key].description
																				: ""
																		}
																		onChange={(e) =>
																			SocInsDeliveryStore.changeSubItem("description", row._id, key, e.target.value)
																		}
																		InputLabelProps={{
																			shrink: true
																		}}
																	/>
																)}
															</Grid>
															{SocInsDeliveryStore.isEditable && (
																<Grid item xs={1}>
																	<Grid container direction="row" justify="flex-end">
																		<Grid item>
																			{countSubItems === index + 1 && (
																				<XsIconButton
																					className="xs-success xs-outline"
																					icon={<i className="fal fa-plus" />}
																					onClick={() => SocInsDeliveryStore.addSubItem(row._id)}
																				/>
																			)}
																			<XsIconButton
																				className="xs-danger xs-outline"
																				icon={<i className="fal fa-times" />}
																				onClick={() => SocInsDeliveryStore.deleteSubItem(row._id, key)}
																			/>
																		</Grid>
																	</Grid>
																</Grid>
															)}
														</Grid>
													</Grid>
												)
											})}
										</Grid>
									</TableCell>
								</TableRow>
							)
						}
					}
				})
			} else {
				this.tableBodyRows.push(
					<TableRow key={1}>
						<TableCell className="textCenter xs-bold" colSpan={15}>
							<FormattedMessage id="Table.NoData" />
						</TableCell>
					</TableRow>
				)
			}
		}
	}

	render() {
		const {order, orderBy} = this.state

		if (this.reloadGrid) {
			this.data = SocInsDeliveryStore.socInsDeliveryList
		}

		this.tableBody()

		return (
			<React.Fragment>
				<Grid container direction="column" spacing={16}>
					<SocInsDeliveryFilter />
					{SocInsDeliveryStore.isLoadingData ? (
						<XsLoading />
					) : SocInsDeliveryStore.changedFilters ? (
						<Grid item className="xs-table-no-data pa-3 borderRadius-1 mt-8">
							<i
								className="far fa-search fa-lg mr-3 pointer"
								onClick={() => {
									if (
										TableStore.tables.hasOwnProperty("socInsDeliveryList") &&
										TableStore.tables["socInsDeliveryList"].hasOwnProperty("index")
									) {
										delete TableStore.tables["socInsDeliveryList"]["index"]
									}

									SocInsDeliveryStore.getFilters(true)
									SocInsDeliveryStore.page = 0
								}}
							></i>
							<FormattedMessage id="Common.label.changeFilterSettingsClkickOnTheMagnifyingToApplyThem" />
						</Grid>
					) : (
						<Grid container item>
							<Grid item xs={12}>
								<Table className="xs-customTable">
									<TableHead>
										<TableRow>
											<TableCell>
												<FormattedMessage id="Common.label.date" />
											</TableCell>
											<TableCell
												sortDirection={order}
												onClick={
													!SocInsDeliveryStore.isEditable
														? this.createSortHandler({columnName: "person_name", type: "string"})
														: null
												}
											>
												{order === "asc" || order === "desc" ? (
													<TableSortLabel active={orderBy === "person_name"} direction={order}>
														<FormattedMessage id="Delivery.List.Person" />
													</TableSortLabel>
												) : (
													<FormattedMessage id="Delivery.List.Person" />
												)}
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.Age" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Common.label.insurer" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.Diagnosis" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Common.label.delivery" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.SenderType" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.Count" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Common.label.payerType" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.Points" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.Currency" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.InsureeType" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.RefundType" />
											</TableCell>
											<TableCell>
												<FormattedMessage id="Delivery.List.Movement" />
											</TableCell>
											{SocInsDeliveryStore.isEditable && <TableCell width="40px" className="xs-align-text"></TableCell>}
											<TableCell className="xs-align-text">
												<FormattedMessage id="Delivery.List.PP" />
											</TableCell>
											{!SocInsDeliveryStore.isEditable && <TableCell className="xs-align-text"></TableCell>}
										</TableRow>
									</TableHead>
									<TableBody>{this.tableBodyRows}</TableBody>
								</Table>
							</Grid>
							<Grid item xs={12}>
								<div className="xs-grid-footer">
									{!SocInsDeliveryStore.isEditable && (
										<TablePagination
											component="div"
											className="xs-table-pagination"
											count={SocInsDeliveryStore.rowCountFull}
											rowsPerPage={SocInsDeliveryStore.rowsPerPage}
											rowsPerPageOptions={[5, 10, 25, 50]}
											labelRowsPerPage={<FormattedMessage id="Table.Pagination.RowPerPage" />}
											labelDisplayedRows={(pager) =>
												`${pager.from}-${pager.to} ${this.props.intl.formatMessage({id: "Table.Pagination.Of"})} ${
													pager.count
												}`
											}
											page={SocInsDeliveryStore.page}
											onChangePage={this.handleChangePage}
											onChangeRowsPerPage={this.handleChangeRowsPerPage}
											ActionsComponent={TablePaginationActions}
										/>
									)}
								</div>
							</Grid>
						</Grid>
					)}
				</Grid>
				<ExportSocInsDeliveryDialog />
				<AddDeliveryDialog payerType="S" />
			</React.Fragment>
		)
	}
}

// import React from "react"
// import {FormattedMessage, injectIntl} from "react-intl"
// import {observer} from "mobx-react"
// import moment from "moment"

// import {Grid} from "@material-ui/core"
// import RouterStore from "../../../../../global/store/RouterStore"
// import UIStore from "../../../stores/UIStore"
// import ExportSocInsDeliveryDialog from "./exportSocInsDeliveryDialog"
// import XsTableServer from "../../../../../global/ui/xsTableServer/xsTableServer"

// import SocInsDeliveryFilter from "./socInsDeliveryFilter"
// import AddDeliveryDialog from "../../patientDetail/patientDelivery/addDeliveryDialog"

// import api from "../../../actions/api"
// import {getUserCompanyInfo} from "../../../../../global/helpers/actions"

// import SocInsDeliveryStore from "../../../stores/SocInsDeliveryStore"

// @injectIntl
// @observer
// export default class SocialInsuranceDeliveryList extends React.Component {
// 	constructor(props) {
// 		super(props)
// 	}

// 	render() {
// 		const companyInfo = getUserCompanyInfo()

// 		return (
// 			<React.Fragment>
// 				<Grid container direction="column" spacing={16}>
// 					<SocInsDeliveryFilter />
// 					{SocInsDeliveryStore.changedFilters ? (
// 						<Grid item className="xs-table-no-data pa-3 borderRadius-1 mt-8">
// 							<i className="far fa-search fa-lg mr-3 pointer" onClick={() => SocInsDeliveryStore.getFilters()}></i>
// 							<FormattedMessage id="Common.label.changeFilterSettingsClkickOnTheMagnifyingToApplyThem" />
// 						</Grid>
// 					) : (
// 						<Grid item>
// 							<XsTableServer
// 								optimizedData={true}
// 								uri={`${api.loadCompanyDeliveries(companyInfo.id, null, "P").getPath()}`}
// 								filterValue={SocInsDeliveryStore.filters}
// 								config={{
// 									columnDefs: {
// 										created_at: {
// 											title: <FormattedMessage id="Common.label.date" />,
// 											type: "string",
// 											design: {
// 												width: "10%",
// 												body: {
// 													formatter: (props) => {
// 														return isSafe(props) && isNotEmpty(props) ? moment(props).format("DD.MM.YYYY") : ""
// 													}
// 												}
// 											}
// 										},
// 										person_name: {
// 											title: <FormattedMessage id="Patient.labels.patient" />,
// 											type: "string",
// 											design: {
// 												width: "15%",
// 												body: {
// 													className: "blueDark xs-bold"
// 												}
// 											}
// 										},
// 										dgn: {
// 											title: <FormattedMessage id="Delivery.List.Diagnosis" />,
// 											type: "string",
// 											design: {
// 												width: "15%"
// 											}
// 										},
// 										delivery: {
// 											title: <FormattedMessage id="Common.label.delivery" />,
// 											type: "string",
// 											design: {
// 												width: "20%"
// 											}
// 										},
// 										count: {
// 											title: <FormattedMessage id="Delivery.List.Count" />,
// 											type: "string",
// 											design: {
// 												width: "10%"
// 											}
// 										},
// 										points: {
// 											title: <FormattedMessage id="Delivery.List.Points" />,
// 											type: "string",
// 											design: {
// 												width: "10%"
// 											}
// 										},
// 										currency: {
// 											title: <FormattedMessage id="Delivery.List.Currency" />,
// 											type: "string",
// 											design: {
// 												width: "10%"
// 											}
// 										},
// 										extension: {
// 											title: <FormattedMessage id="Delivery.List.Extension" />,
// 											type: "string",
// 											design: {
// 												width: "10%"
// 											}
// 										}
// 									},
// 									options: {
// 										showCursor: true,
// 										mapper: (dataRow) => {
// 											return {
// 												created_at: dataRow.created_at,
// 												person_name: dataRow.person_name,
// 												person_id: dataRow.person_id,
// 												dgn: isSafe(dataRow.diagnosis)
// 													? dataRow.diagnosis.code_ext + " " + dataRow.diagnosis.name_ext
// 													: "",
// 												delivery: dataRow.item_code_ext + " " + dataRow.item_name_ext,
// 												count: dataRow.count,
// 												points: dataRow.price_in_points,
// 												currency: dataRow.price_in_currency,
// 												extension: isSafe(dataRow.delivery_extension) ? dataRow.delivery_extension.code_ext : ""
// 											}
// 										},
// 										onRowClick: (row) => {
// 											if (isSafe(row.person_id)) {
// 												RouterStore.push(`/patient?id=${row.person_id}`)
// 												// UIStore.mainMenuTab = "mainmenu"
// 												UIStore.mainMenuTab = "patientDetail"
// 											}
// 										},
// 										paging: {
// 											rowsPerPageOptions: [10, 15]
// 										}
// 									}
// 								}}
// 							/>
// 						</Grid>
// 					)}
// 				</Grid>
// 				<ExportSocInsDeliveryDialog />
// 				<AddDeliveryDialog payerType="S" />
// 			</React.Fragment>
// 		)
// 	}
// }
